// Functional types for deterministic ownership routing (R40).
// Single source of truth — imported by the team edit page (functional-type
// tagging) and the Drift Routing Policy editor. Values must match the backend
// model.FunctionalType enum.
export const FUNCTIONAL_TYPES = [
  { value: 'tpm', label: 'Third-Party Mgmt (TPM)' },
  { value: 'infosec', label: 'InfoSec' },
  { value: 'model_risk', label: 'AI / Model Risk' },
  { value: 'resilience', label: 'Resilience' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'business_owner', label: 'Business Owner' },
  { value: 'executive', label: 'Executive' },
]
